<template>
    <v-layout row wrap class="pl-3 pr-2">
        <confirmation-header-text
            text="NRN Visa details"
            icon="mdi-alpha-n-box"
            class="ml-1"
        />
        <v-layout row wrap class="mx-0 ml-4" v-if="!isOld">
            <v-flex sm3>
                <list-item-detail
                    :sub_title="application_data.full_address"
                    title="Full address"/>
            </v-flex>
            <v-flex sm3>
                <list-item-detail
                    :sub_title="application_data.full_address"
                    title="Full address"/>
            </v-flex>
            <v-flex sm3>
                <list-item-detail
                    :sub_title="application_data.nrn_card_number"
                    title="NRN card number"/>
            </v-flex>
            <v-flex sm3>
                <list-item-detail
                    :sub_title="application_data.nrn_card_expiry_date"
                    title="NRN card expiry date"/>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import ListItemDetail from "../../ListItemDetail";

    export default {
        computed: {
            application_data() {
                return this.$store.state.VisaRequestSingle.visaRequest.extra.application_data;
            },
            isOld() {
                return this.$store.state.VisaRequestSingle.visaRequest.old;
            },
        },
        components: {
            ConfirmationHeaderText, ListItemDetail
        }

    };
</script>

<style>
</style>
